module.exports = __webpack_public_path__ + "static/header-06f522051e6fe44d17897660101ae2db.png";